import { useQuery } from 'react-query';

import { getTrapsActivityLineChartData } from 'api/analitics/MCTCharts/2_getTrapsActivityLineChart';

export const useGetTrapsActivityLineChart = (
  slug: string,
  period: string,
  trapType: string,
  startDate: string,
  endDate: string,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['TrapsActivityLineChartData', trapType],
    () => getTrapsActivityLineChartData(slug, period, trapType, startDate, endDate),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTrapsActivityLineChart;
